import React, { FC } from "react";
import { Form, Button, Select } from "antd";
import { FormattedMessage } from "react-intl";
import { useGlobalState } from "../../context/Provider";
import { handleSelectToWarehouse } from "../../constants/product.constant";

interface AdditionBatchTypeFormIProps {
  handleSubmit: any;
  isDisable: boolean;
  loading: boolean;
  isMobile?: boolean;
}

const AdditionBatchTypeForm: FC<AdditionBatchTypeFormIProps> = (props) => {
  const { loading, isDisable, handleSubmit } = props;
  const [form2] = Form.useForm();
  const { langState, warehouserList }: any = useGlobalState();
  const language: string = langState.locale;

  const { Option } = Select;

  return (
    <Form
      form={form2}
      layout="inline"
      style={{ alignItems: "start" }}
      initialValues={{ modifier: "public" }}
      onFinish={handleSubmit}
      className="my-3"
    >
      <Form.Item
        label={language === "en-US" ? "Warehosue name" : "نام انبار"}
        name="warehouseId"
        rules={[
          {
            required: true,
            message:
              language === "en-US"
                ? "Please select your typs!"
                : "لطفا نوع رو انتخاب کنید ",
          },
        ]}
      >
        <Select style={{ width: 180 }} placeholder="select to warehouse">
          {warehouserList.data.map((item: any) => (
            <Option value={item.id} key={item.id}>
              {item.name}
            </Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item
        label={language === "en-US" ? "type" : "نوع"}
        style={{ flexDirection: "row", alignItems: "start" }}
        name="type"
        rules={[
          {
            required: true,
            message:
              language === "en-US"
                ? "Please select your typs!"
                : "لطفا نوع رو انتخاب کنید ",
          },
        ]}
      >
        <Select
          placeholder={language === "en-US" ? "select to type" : "انتخاب نوع"}
          style={{ width: 200 }}
        >
          {handleSelectToWarehouse.map((item: any) => (
            <Option key={item.value} value={item.value}>
              {item.label}
            </Option>
          ))}
        </Select>
      </Form.Item>
      <Button
        type="primary"
        htmlType="submit"
        disabled={isDisable}
        loading={loading}
      >
        <FormattedMessage id="additionBatch.submit" />
      </Button>
    </Form>
  );
};

export default AdditionBatchTypeForm;
